<template>
    <rkm-form
        ref="RkmForm"
    >

        <rkm-alert show color="warning">
            <strong>Atenção:</strong> São permitidos apenas arquivos do tipo PDF, com no máximo 2mb.
            <p v-show="multiple" class="mb-0">O laudo deve estar nomeado de acordo com o número do pedido.<br>
            Se necessário incluir mais de um laudo para o mesmo pedido, deve-se separar o nome do arquivo conforme o
                seguinte exemplo: 1234_1, 1234_2, 1234_3...</p>
        </rkm-alert>

        <rkm-alert show info v-if="item">
            <strong>Paciente:</strong>

            {{ item.pacienteNome }}

            <strong v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                ({{ item.pacienteNomeSocial }})
            </strong> -

            <strong>Prontuário: </strong>{{ item.pacienteProntuario }} -
            <strong>Agendamento: </strong>{{ item.agendamentoNumero }}
        </rkm-alert>

        <rkm-area title="Importar laudo">

            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-file
                        label="Laudo(s)"
                        v-model="model.laudo"
                        type="file"
                        placeholder="SELECIONE O(S) LAUDO(S)"
                        accept=".pdf"
                        browse-text="Selecionar"
                        ref="file-input"
                        multiple
                    >
                        Pesquisar
                    </rkm-form-file>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click.stop="save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-show="!multiple"
            title="Laudos importados"
            no-margin-top
        >

            <rkm-table
                :items="items"
                :fields="fields.tables.laudo"
                hide-filters
                hide-pagination
                tag="div"
            >
                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        @click="handleDownload(item)"
                        color="primary"
                        small
                        title="Baixar"
                    >
                        <rkm-icon icon="download" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </rkm-form>
</template>

<script>

//Vuex
import {mapActions} from 'vuex'

//Mixins
import {repository, error, data, object} from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {

            return {
                tables: {
                    laudo: [
                        { key: 'arquivo', label: 'Laudo', sortable: true },
                        { key: 'data', label: 'Data', sortable: true },
                        { key: 'usuario', label: 'Responsável', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            laudo: this.getConectaSusRepository('exameLaboratorial.importarLaudo'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        model: {
           laudo: null,
        },
        msg: '',
        fileSize: true,
        enums: { preferenciaNome },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.item) {

                this.setLoading()

                this.repositories.laudo.show({
                    agendamento_id: this.item.agendamentoId,
                })
                .then(({data}) => {

                    this.items = data
                    })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.handleLaudo()) {

                        this.setLoading()

                        this.repositories.laudo.store(this.prepareData())
                        .then(response => {

                            if (!this.multiple) {

                                this.items = response.data
                                this.handleStatus()
                            }

                            this.resetForm()

                            if (this.msg !== '') {

                                this.showAlert(`Os seguintes laudos NÃO foram importados, pois ultrapassam o limite
                                    máximo de 2mb: <strong>${this.msg}</strong>`, "Atenção")
                            } else {

                                this.showSaveNotification('Laudo(s) importado(s) com sucesso!')
                            }


                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                    }
                })
        },
        handleLaudo() {

            if(!this.model.laudo || this.model.laudo && this.model.laudo.length == 0){

                this.showValidationNotification("É necessário selecionar ao menos um laudo.")

                return false
            }

            return true
        },
        handleStatus() {

            if (this.items.length > 0) {
                this.item.status = 'LAUDO IMPORTADO'
            } else {
                this.item.status = 'LAUDO NÃO IMPORTADO'
            }
        },
        prepareData() {


            let arquivo = this.model.laudo
            let nomeArquivo = this.multiple ? null : this.item.agendamentoNumero
            let quantidade = this.multiple ? null : this.item.length
            let formData = new FormData()
            this.msg = ''

            formData.append('agendamento_id', this.multiple ? null : this.item.agendamentoId)
            formData.append('quantidade', quantidade)
            formData.append('multiple', this.multiple)

            arquivo.forEach((element, index) => {

                if (element.size > 2000000) {

                    if (this.msg == '') {

                        this.msg = this.msg.concat(`${element.name}`)

                    } else {

                        this.msg = this.msg.concat(`, ${element.name}`)
                    }
                } else {

                    if (this.multiple) {

                        formData.append(`laudo[]`, new File([element], `${element.name}`))
                    } else {

                        if (index == 0) {
                            formData.append(`laudo[]`, new File([element], `${nomeArquivo}.${element.name.split('.').pop()}`))
                        } else {
                            formData.append(`laudo[]`, new File([element], `${nomeArquivo}_${index+1}.${element.name.split('.').pop()}`))
                        }
                    }
                }
            });

            return formData
        },
        resetForm() {

            this.model.laudo = null
        },
        handleDownload(item) {

            this.repositories.laudo.download(item.id)
                .then(response => {

                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')

                    link.href = window.URL.createObjectURL(blob)
                    link.download = file

                    link.click()
                })
                .catch(this.handleError)
        },
        handleDestroy(item) {

            const destroy = () => this.repositories.laudo.destroy(item.id)
                .then(() => {

                    const objId = this.items.findIndex((obj => obj.id == item.id));

                    this.items.splice(objId, 1)
                    this.handleStatus()
                })

            this.showDeleteConfirmation('Deseja realmente excluir o laudo?', destroy, this.handleError)
        },
    },
    mixins: [repository, error, data, object],
    props: {
        item: { type: Object, default: null },
        multiple: { type: Boolean, default: false },
    },
}
</script>